import { observable, action, runInAction, computed } from 'mobx';
import BasePaginationStore from '@store/Common/BasePaginationStore';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import {message} from "antd";

class Item {
  constructor(data) {
    this.init(data);
  }

  @action
  init(data) {
    for(let attr in data) {
      this[attr] = data[attr];
    }
  }

  @observable
  id = "";

  /**
   * 用户姓名
   */
  @observable
  name = "";

  /**
   * 用户类型
   */
  @observable
  type = "";

  /**
   * 用户账号
   */
  cellphone = "";

  /**
   * 用户是否已激活（实名认证）
   * 0: 未激活
   * 1: 已激活
   */
  @observable
  is_active = "";

  /**
   * 用户是否被冻结
   */
  @observable
  is_frozen = "";

  /**
   */
  @observable
  wallet_id = "";

  /**
   * 用户角色
   */
  @observable
  role_array = [];
}

class PaginationStore extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 */
class FilterStore {
  @observable
  name;

  @observable
  cellphone;

  @action
  setAttr(attrs) {
    for(let attr in attrs) {
      this[attr] = attrs[attr]
    }
  }

  getAttr() {
    return {
      name: this.name,
      cellphone: this.cellphone
    }
  }

  @action
  resetAttr() {
    this.name = '';
    this.cellphone = '';
  }
}

let filter_store = new FilterStore();

class ItemStore {

  constructor(pagination) {
    this.init(pagination);
  }

  @action
  init(pagination){
    this.pagination_store = pagination;
  }

  @observable
  item_map = new Map();

  /**
   * item 数组列表
   */
  @computed
  get item_array() {
    let res = [];
    this.item_map.forEach((values, key) => {
      res.push(values);
    });
    return res;
  }

  @observable
  pagination_store;

  @observable
  is_modal_show = false;

  @action
  async openModal() {
    await this.searchByFilter({
      page_cur: 1
    });
    debugger
    runInAction(() => {
      this.is_modal_show = true;
    });
  }

  @action
  closeModal() {
    this.is_modal_show = false;
    filter_store.resetAttr();
  }

  /**
   * 根据条件搜索item
   * @param {*} page_opts
   */
  async searchByFilter(page_opts){
    let page_option = {
      page_cur: this.pagination_store.page_cur,
      page_size: this.pagination_store.page_size,
      ...filter_store.getAttr(),
      ...page_opts
    }
    let res = await this._getItemArray(page_option);
    return res;
  }

  /**
   * 获取item 列表
   */
  async _getItemArray(page_option = {}) {
    let url = fetchUrl.user.index;
    let res = await service.fetchData({
      path: url,
      params: {
        ...page_option
      }
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        runInAction(() => {
          // console.log(res);
          this.item_map.clear();
          res.data.pageData.forEach((item, index) => {
            this.item_map.set(item.id, new Item(item));
          });
          // console.log(this.item_map);
          this.pagination_store.setAttr(res.data.page);
        })
      },
      fail_handle: (res) => {
        message.error(res.error.error_data,3);
        this.pagination_store.clear();
        filter_store.resetAttr();
        this.item_map.clear();
      }
    })
    return res;
  }

  /**
   * 升级为代理
   * @param {Item} item item
   */
  async adoptAgent(item){
    let url = fetchUrl.agent.adopt_agent;
    let res = await service.fetchData({
      path: url,
      params: {
        id: item.id
      }
    });
    return res;
  }
}

let pagination_store = new PaginationStore();
let item_store = new ItemStore(pagination_store);

export {
  pagination_store,
  filter_store
}
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Agent/UpdateToAgentStore.js